import React from 'react';
import UserCentricsOverlay from './UserCentricsOverlay';
import MainContainer from './MainContainer';
import { Loader } from '@googlemaps/js-api-loader';
import Widget from '../components/Widget';
import Usercentrics from '@usercentrics/cmp-browser-sdk';

export default class ConsentMiddlewareComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMaps: false,
      showModal: false,
    };
    this.UC_GOOGLE_MAPS_TEMPLATE_ID = "5GHgwNDsd"; // '5GHgwNDsd' (PROD), 'u_9CaOfxv' (npr.myhermes.de)
    this.UC = new Usercentrics("9CIwpOaf"); // '9CIwpOaf' (PROD), 'KnI5gpc2' (npr.myhermes.de)
  }

  showModal = () => {
    this.setState({
      showModal: true,
    });
    window.wts.push([
      "send",
      "click",
      { linkId: "Consentbanner Google Maps angezeigt" },
    ]);
  };

  hideModal = () => {
    this.setState({
      showModal: false,
    });
  };

  showMaps = () => {
    this.setState({
      showMaps: true,
    });
  };

  hideMaps = () => {
    this.setState({
      showMaps: false,
    });
  };

  acceptGoogleMapsConsent = () => {
    const loader = new Loader({
      apiKey: "AIzaSyB12xvHjP7pBsbL0IaitKFQOSSrnbWk7zU",
      version: "weekly",
      libraries: ["places"],
    });
    setTimeout(() => {
      loader.load();
    }, 1000);

    this.UC.updateServices([
      { serviceId: this.UC_GOOGLE_MAPS_TEMPLATE_ID, status: true },
    ]).then(() => {
      const getCategories = this.UC.getCategoriesBaseInfo();
      const getServices = this.UC.getServicesBaseInfo();
    });

    this.hideModal();
    this.showMaps();
    window.wts.push([
      "send",
      "click",
      { linkId: "Consentbanner Google Maps akzeptiert" },
    ]);
  };

  showOrHideMaps = (isMapsAccepted) => {
    if (isMapsAccepted) {
      this.hideModal();
      this.showMaps();
    } else {
      this.hideMaps();
      this.showModal();
    }
  };

  // without timeout the push below is not working
  isGoogleMapsAccepted() {
    setTimeout(() => {
      const services = this.UC.getServicesBaseInfo();
      const isMapsAccepted = services[9]?.consent.status;
      this.showOrHideMaps(isMapsAccepted);
    }
      , 1000);
  }

  initUsercentricsSDK = (
    retryCount = 0,
    maxRetries = 3,
    delayBetweenRetries = 1000
  ) => {
    this.isGoogleMapsAccepted();

    this.UC.init()
      .then(() => {
        // check if sdk is initialized by checking if getServices returns an array of services
        if (typeof this.UC.getServicesBaseInfo() === "object") {
          console.log("Usercentrics SDK initialized");
          this.isGoogleMapsAccepted();
        } else {
          if (retryCount < maxRetries) {
            console.log(
              "Usercentrics SDK is not initialized, retrying ..."
            );
            // Retry initialization after a delay
            setTimeout(() => {
              this.initUsercentricsSDK(
                retryCount + 1,
                maxRetries,
                delayBetweenRetries
              );
            }, delayBetweenRetries);
          } else {
            console.error("Max retries reached. Initialization failed.");
          }
        }
      })
      .catch((error) => {
        console.error("General error initializing Usercentrics SDK:", error);
      });
  };

  componentDidMount() {
    this.initUsercentricsSDK();
  }

  render() {
    return (
      <div className="main">
        {this.state.showModal ? (
          <UserCentricsOverlay
            click_acceptGoogleMapsConsent={() => this.acceptGoogleMapsConsent()}
          />
        ) : null}
        {this.state.showMaps && !this.props.isWidget ? <MainContainer /> : null}
        {this.state.showMaps && this.props.isWidget ? <Widget /> : null}
      </div>
    );
  }
}
